// Tema claro u oscuro del portal. Predeterminado: CLARO, aunque el sistema esté en oscuro (Andrés, 6-oct).
// Por qué: la RH que lo usa tiene 60 y tantos años, y letra oscura sobre fondo claro se lee mejor con la edad
// (la pupila es más chica y el cristalino dispersa más la luz; el texto claro sobre negro «se corre»). Quien
// prefiera oscuro lo elige con el botón del encabezado y se recuerda en este navegador.
import { useCallback, useState } from "react";
import { guardarPref, leerPref } from "./util";

export type Tema = "claro" | "oscuro";
const CLAVE = "tema";

export const leerTema = (): Tema => (leerPref(CLAVE) === "oscuro" ? "oscuro" : "claro");

/** Pone el tema en <html data-theme> (lo lee portal.css) y en color-scheme (barras y controles nativos). */
export function aplicarTema(t: Tema) {
  try {
    const r = document.documentElement;
    r.dataset.theme = t === "oscuro" ? "dark" : "light";
    r.style.colorScheme = t === "oscuro" ? "dark" : "light";
  } catch {
    /* sin DOM: nada que pintar */
  }
}

export function useTema(): [Tema, (t: Tema) => void] {
  const [tema, setTema] = useState<Tema>(leerTema);
  const cambiar = useCallback((t: Tema) => {
    guardarPref(CLAVE, t);
    aplicarTema(t);
    setTema(t);
  }, []);
  return [tema, cambiar];
}
